var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-dark btn-sm",on:{"click":_vm.hideQuestionImage}},[(_vm.slideActive.showQuestionImage)?_c('span',[_vm._v(_vm._s(_vm.$t('Hide image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Show image')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }